import { render, staticRenderFns } from "./archive.vue?vue&type=template&id=f4afdd9a&scoped=true&"
var script = {}
import style0 from "./archive.vue?vue&type=style&index=0&id=f4afdd9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4afdd9a",
  null
  
)

export default component.exports